import { render } from "./GoalTypeSelect.vue?vue&type=template&id=5bae1cf0"
import script from "./GoalTypeSelect.vue?vue&type=script&lang=ts"
export * from "./GoalTypeSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script